export interface Usuario {
  email: string;
  id: string;
  name: string;
  permissionGroup: string;
  status: string;
  checked: boolean;
}
export interface Fundo {
  idInvestmentFund: string;
  code: string;
  name: string;
  checked: boolean;
}
export class Grupo {
  id: string;
  name: string;
  users: Usuario[];
  investmentFunds: Fundo[];
  funds: Fundo[];
  constructor() {}
}

export class FundoId {
  id: string;
  code?: string;
  name?: string;
  cnpj?: string;
  constructor() {}
}

export class UsuarioId {
  id: string;
  constructor() {}
}
export class GrupoPost {
  name: string;
  id: string;
  users: UsuarioId[];
  funds: FundoId[];
  constructor() {}
}
